import BaseContent from "../api/club-cms/base.content";
import { CmsEditorState } from '../api/club-cms';
import Club from './../api/club';
import ClubActions from './club';
import {notify} from "./message";
import {grabImages} from "../api/club-cms/image-graber";

interface iAddNodeAction {
    type: string;
    node: BaseContent,
    parent: BaseContent
  }

export const ADD_NODE = 'club-cms-add-node';
export const REMOVE_NODE = 'club-cms-add-node';
export const CMS_EDITOR_LOADING = 'club-cms-loading';
export const CMS_EDITOR_LOADED = 'club-cms-loaded';
export const LOAD = 'club-cms-loaded';
export const UPDATE_CMS_EDITOR = 'club-cms-update';
export const CMS_EDITOR_SAVING = 'club-cms-saving';
export const CMS_EDITOR_SAVED = 'club-cms/saved';
export const CMS_EDITOR_SAVED_FAILED = 'club-cms/saved-failed';

export default class ClubCMSAction {
  public static updateCmsEditor(cmsEditorState: CmsEditorState) {
    return {
      type: UPDATE_CMS_EDITOR,
      cmsEditorState
    }
  }

  public static save(cmsEditorState: CmsEditorState) {
    return async (dispatch: Function, getState: Function) => {
      let state: any = getState();
      let model = state.club.model;

      dispatch({
        type: CMS_EDITOR_SAVING
      });

      try {

        dispatch(notify('Saving images'));
        await model.saveImages(cmsEditorState);
        dispatch(notify('Saving info'));
        let savedClub = await model.updateInfo(cmsEditorState);

        dispatch({
          type: CMS_EDITOR_SAVED,
          savedClub
        });

        dispatch(notify('Info saved successful'));

        return savedClub;

      }
      catch(error) {
        dispatch({
          type: CMS_EDITOR_SAVED_FAILED,
          error
        });

        dispatch(notify('Info saving has failed. Please contact PM'));
      }
    }
  }
  public static applyClub(club: Club) {
      let cmsEditorState = new CmsEditorState();
      if(club.info instanceof Array) {
        cmsEditorState = cmsEditorState.parse(club.info || []);
      }
      return {
        type: CMS_EDITOR_LOADED,
        cmsEditorState,
        club
      };
  }

}




// WEBPACK FOOTER //
// ./src/actions/club-cms.ts